import { Routes } from '@angular/router';
import { LazyRouteGuardService } from '@cbuild/core';

export const routes: Routes = [
  {
    path: 'dashboard',
    loadComponent: () =>
      import('./dashboard/dashboard.component').then(m => m.DashboardComponent),
    canLoad: [LazyRouteGuardService]
  },
  {
    path: '',
    redirectTo: '/dashboard',
    pathMatch: 'full'
  },
  {
    path: 'accounts',
    loadChildren: () =>
      import('./login/login-routing.module').then(m => m.LoginRoutes)
  },
  {
    path: 'op-maintenance',
    loadChildren: () =>
      import('./op-maintenance/op-maintenance.route').then(
        m => m.OperationMaintenanceRoutes
      )
  },
  {
    path: 'bms',
    loadChildren: () => import('./bms/bms.route').then(m => m.BmsRoutes)
  },
  // {
  //   path: 'work-space',
  //   loadChildren: () =>
  //     import('./work-space/work-space.route').then(m => m.WorkSpaceRoutes)
  // },
  {
    path: '**',
    redirectTo: '/dashboard'
  }
];
